export enum JobActionType {
  DUPLICATE = 'duplicate',
  SEND = 'send',
  RESEND = 'resend',
  REMOVE_ACCEPTED = 'remove-accepted',
  MARK_AS_ACCEPTED = 'mark-as-accepted',
  MARK_AS_DECLINED = 'mark-as-declined',
  MARK_AS_SENT = 'mark-as-sent',
  INACTIVATE_AND_EDIT = 'inactivate-and-edit',
  EDIT = 'edit',
}
